import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {synchronizationsActions} from '..';
import useIsMountedRef from 'common/hooks/useIsMountedRef';
import {ISynchronization} from 'types/diplomat/transaction/Synchronization';

const actionsMap = {
   pgp: synchronizationsActions.getRefsPgp,
   ssh: synchronizationsActions.getRefsSsh,
   ssl: synchronizationsActions.getRefsSsl,
   proxy: synchronizationsActions.getRefsProxy,
   partner: synchronizationsActions.getRefsPartner,
   transaction: synchronizationsActions.getRefsTransaction,
};

export const useSynchronizationsRefs = (
   id: string,
   type: 'pgp' | 'ssh' | 'ssl' | 'proxy' | 'partner' | 'transaction'
) => {
   const isMountedRef = useIsMountedRef();
   const dispatch = useDispatch();
   const [synchronizations, setSynchronizations] = useState<ISynchronization[]>([]);
   useEffect(() => {
      const action = actionsMap[type];
      dispatch(
         action(id, {
            onSuccess: (_synchronizations: ISynchronization[]) => {
               if (isMountedRef.current) {
                  setSynchronizations(_synchronizations);
               }
            },
         })
      );
   }, [dispatch, id, isMountedRef, type]);

   return synchronizations;
};
